/**
 * Host-helpers voor de tenant-beheer-split (ADR-0028).
 *
 * De app-host en de beheer-host zijn aparte hostnames die de backend per tenant
 * kent (`/api/v1/tenant` → `app_host` / `manage_host`); de beheer-host is
 * standaard `manage-<slug>` maar per tenant overschrijfbaar. De SPA bouwt geen
 * hostnames meer via string-prefixing — ze komen uit de meta — en plakt alleen
 * het huidige protocol + poort ervoor.
 */

/** Bouwt een absolute URL voor een bare hostname met het huidige protocol/poort. */
export function hostUrl(host: string, path = ''): string {
  const port = window.location.port ? `:${window.location.port}` : '';

  return `${window.location.protocol}//${host}${port}${path}`;
}

/** Consume-URL op de eindgebruiker-host voor een cross-host handoff-token. */
export function handoffConsumeUrl(appHost: string, token: string): string {
  return hostUrl(appHost, `/?handoff=${encodeURIComponent(token)}`);
}
